export const ctaBuyAHomeIcon = '/assets/images/cta-buy-a-home-icon.svg';
